import { Injectable } from '@angular/core';
import { IPaetepCfGenericMapperService } from '../../interfaces/paetep-cf-generic-mapper.service';
import { ContextInformationAnswerConfig } from 'src/app/model/observation/custom-forms/answer-configs/context-information-answer-config.model';
import { PaetepCfContextInfoModel } from 'src/app/components/custom-form-enhancements/edl-cf-extensions/item-models/paetep-cf-context-info.model';
import { CustomFormQuestionDisplayDTO } from 'src/app/model/observation/custom-forms/custom-form-question-dto.model';
import { EdlCfGenericModel, MAX_TITLE_LENGTH } from '@edl-development/edl-custom-forms';
import { CustomFormQuestionType } from 'src/app/model/enum/observations/custom-forms/custom-form-question-type.enum';
import { ContextInfoCustomFormType } from 'src/app/model/enum/observations/custom-forms/custom-form-context-info-type.enum';
import { PaetepCfAnswerContextInfoModel } from 'src/app/components/custom-form-enhancements/edl-cf-extensions/answer-models/paetep-cf-answer-context-info.model';
import { CustomFormsHelpersService } from '../../custom-forms-helpers/custom-forms-helpers.service';

@Injectable({
    providedIn: 'root'
})
export class PaetepCfContextInfoMapperService 
    implements IPaetepCfGenericMapperService<ContextInformationAnswerConfig, PaetepCfContextInfoModel, string, PaetepCfAnswerContextInfoModel>  {

    constructor(private customFormsHelpersService: CustomFormsHelpersService) { }

    public toEdlModel = (child: CustomFormQuestionDisplayDTO<ContextInformationAnswerConfig>): PaetepCfContextInfoModel => {
        return {
            title: child.label,
            contextType: child.answerConfig?.selectedContext
        }
    }

    public toPaetepModel = ({
        formID, 
        sectionID,
        displayOrder,
        groupOrder,
        question
    } : {
        formID: string, 
        sectionID: string, 
        displayOrder: number,
        groupOrder: number,
        question: EdlCfGenericModel<PaetepCfContextInfoModel>
    }): CustomFormQuestionDisplayDTO<ContextInformationAnswerConfig> =>  {
        return this.customFormsHelpersService.createCustomFormQuestion<ContextInformationAnswerConfig>({
            $type: CustomFormQuestionType.CONTEXTUAL_INFORMATION,
            typeID: CustomFormQuestionType.CONTEXTUAL_INFORMATION,
            formID,
            sectionID,
            questionID: question.id,
            readOnly: false,
            required: false,
            displayOrder,
            groupOrder,
            label: (question.config.title ?? '').substring(0, MAX_TITLE_LENGTH),
            displayLabel: true,
            answerConfig: {
                selectedContext: question.config.contextType ?? ContextInfoCustomFormType.BUILDING
            }
        });
    }

    public toEdlAnswer = (answer: string = '', question: CustomFormQuestionDisplayDTO<ContextInformationAnswerConfig>) => answer;

}
